import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';

import { SharedService } from 'src/app/core/services/shared.service';

declare const UIkit: any;

@Component({
  selector: 'app-full-text-modal',
  templateUrl: './full-text-modal.component.html',
  styles: ['.text { white-space: pre-wrap; }']
})
export class FullTextModalComponent implements OnInit {
  @Input() text: string;
  @Input() title: string;
  @ViewChild('modal', { static: true }) modal: ElementRef;

  constructor(private sharedService: SharedService) {}

  ngOnInit() {
    UIkit.modal('#showFullTextModal').show();

    UIkit.util.on('#showFullTextModal', 'hidden', this.sharedService.deleteModal.bind(this, this.modal));
  }
}
